/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
// reactstrap components
import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
} from 'reactstrap';
// core components
import Header from 'components/Headers/Header.js';
import { axiosGet } from 'util/apiConfig.js';
import { dateForPaymentListing } from 'util/constance';
import moment from 'moment';
class CancelledSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      allCancelledSection: [],

      page: 1,
      totalPage: 0,
      limit: 10,
      search: '',

      successModal: false,
      successMessage: '',
      errorModal: false,
      errorMessage: '',
    };
  }

  componentDidMount() {
    const classId = localStorage.getItem("classId");
    this.setState(
      {
        classId: classId ? classId : null,
        allCancelledSection: [],
      },
      () => {
        this.getAllCancelledSection();
      }
    );
  }

  componentWillUnmount() {
    clearTimeout(this.searchTimer);
  }

  // Search is sent after a short pause in typing and always starts again from page 1.
  onSearchChange = (e) => {
    const search = e.target.value;
    this.setState({ search });
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.setState({ page: 1 }, this.getAllCancelledSection), 400);
  };

  // for getting all approved student -
  getAllCancelledSection = () => {
    const { page, limit, classId, search } = this.state;
    // Only the latest request may update the table, so a slow earlier search can't overwrite it.
    const requestId = (this.requestId || 0) + 1;
    this.requestId = requestId;
    this.setState({ loading: true, errorMessage: '', allCancelledSection: [] });
    let url = `session/get-session-cancel-by-student/${page}/${limit}?view=learners`;
    if (classId) {
        url += `&classId=${encodeURIComponent(classId)}`;
    }
    if (search.trim()) {
        url += `&search=${encodeURIComponent(search.trim())}`;
    }
    axiosGet(url)
      .then((response) => {
        if (requestId !== this.requestId) return;
        if (!response.isError) {
          this.setState({
            loading: false,
            allCancelledSection: response.data?.result || [],
            totalPage: response.data?.noofpage,
          });
        } else {
          this.setState({ loading: false, errorMessage: 'Unable to load learner activity. Please try again.' });
        }
      })
      .catch((error) => {
        if (requestId !== this.requestId) return;
        this.setState({ loading: false, errorMessage: 'Unable to load learner activity. Please try again.' });
      });
  };

  // For changing page -
  changePage = (status) => {
    if (this.state.loading) return;
    if (status === 'next' && !this.state.errorMessage && this.state.page < this.state.totalPage) {
      this.setState({ page: this.state.page + 1 }, () => this.getAllCancelledSection());
    } else if (status === 'prev' && this.state.page > 1) {
      this.setState({ page: this.state.page - 1 }, () => this.getAllCancelledSection());
    }
  };

  render() {
    let { loading, allCancelledSection, page, totalPage, errorMessage, search } = this.state;
    return (
      <>
        <Header />
        {/* Page content */}
        <Container className='mt--7' fluid>
          {/* Table */}
          <Row>
            <div className='col'>
              <Card className='shadow'>
                <CardHeader className='border-0'>
                  <h3 className='mb-0'>Learner Disengagement</h3>
                  <p className='text-muted mt-2 mb-0'>Learners in running classes who missed classes in the past 30 days (student or coach no-shows, student or coach leave, student cancellations), highest count first.</p>
                  <input
                    type='search'
                    className='form-control mt-3'
                    style={{ maxWidth: 360 }}
                    placeholder='Search by section name, coach or email'
                    aria-label='Search learners by section name, coach or email'
                    maxLength={100}
                    value={search}
                    onChange={this.onSearchChange}
                  />
                </CardHeader>
                <Table className='align-items-center table-flush' responsive>
                  <thead className='thead-light'>
                    <tr>
                      <th scope='col'>Learner</th>
                      <th scope='col'>Coach</th>
                      <th scope='col'>Last Class Complete</th>
                      <th scope='col' aria-sort='descending'># of Missed in 30D ↓</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading && <tr><td colSpan={4} role='status'>Loading learner activity…</td></tr>}
                    {!loading && Boolean(errorMessage) && <tr><td colSpan={4} role='alert'>
                      {errorMessage} <button type='button' className='btn btn-link p-0' onClick={this.getAllCancelledSection}>Retry</button>
                    </td></tr>}
                    {!loading && !errorMessage && allCancelledSection.length === 0 &&
                      <tr><td colSpan={4}>{search.trim() ? `No learners match "${search.trim()}".` : 'No learners with missed classes in the past 30 days.'}</td></tr>}
                    {!loading && !errorMessage && allCancelledSection.map((data) => (
                      <tr key={`${data.sectionId || ''}|${data.email}`}>
                        <td>{data.learnerName || data.email}
                          {data.learnerName && <small className='d-block text-muted'>{data.email}</small>}
                        </td>
                        <td>{data.coach || (data.coaches && data.coaches.length ? data.coaches.join(', ') : 'Unknown coach')}</td>
                        <td>{data.lastClassComplete ? moment(data.lastClassComplete).format(dateForPaymentListing) : 'No completed class recorded'}</td>
                        <td>{data.missedIn30D}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <CardFooter className='py-4'>
                  <nav aria-label='Learner activity pages'>
                    <Pagination
                      className='pagination justify-content-end mb-0'
                      listClassName='justify-content-end mb-0'
                    >
                      <PaginationItem className={!loading && page > 1 ? '' : 'disabled'}>
                        <PaginationLink
                          href='#'
                          onClick={(e) => { e.preventDefault(); this.changePage('prev'); }}
                        >
                          <i className='fas fa-angle-left' />
                          <span className='sr-only'>Previous</span>
                        </PaginationLink>
                      </PaginationItem>

                      <PaginationItem className='active'>
                        <PaginationLink onClick={(e) => e.preventDefault()}>
                          {page}
                        </PaginationLink>
                      </PaginationItem>

                      <PaginationItem
                        className={!loading && !errorMessage && totalPage > page ? '' : 'disabled'}
                      >
                        <PaginationLink href='#' onClick={(e) => { e.preventDefault(); this.changePage('next'); }}>
                          <i className='fas fa-angle-right' />
                          <span className='sr-only'>Next</span>
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </nav>
                </CardFooter>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}

export default CancelledSection;
